import { useState } from "react";
import useAsyncEffect from "use-async-effect";

import isServer from "../utils/isServer";

const EXPERIMENTS_API = "/api/v1/experiments";

function getTrackingUrl() {
  if (isServer()) return null;

  return window.location.href.indexOf("www") !== -1
    ? "https://trk.ppassets.com/experiments"
    : "https://earth-trk.ppassets.com/experiments";
}

interface Election {
  name: string;
}

interface ExperimentsClient {
  getUserElectionForFeature: (feature: string) => Election;
}

interface ExperimentState {
  loading: boolean;
  error?: Error;
  election?: Election;
}

let client: ExperimentsClient;

function useExperiment(feature: string) {
  const [state, setState] = useState<ExperimentState>({
    loading: true,
    error: undefined,
    election: undefined,
  });

  useAsyncEffect(async () => {
    if (isServer()) return;

    if (!client) {
      try {
        const ExperimentsClient = (
          await import("@paperlesspost/experiments-js")
        ).default;
        client = new ExperimentsClient(EXPERIMENTS_API, getTrackingUrl());
      } catch (err: any) {
        setState({ election: undefined, loading: false, error: err });
        return;
      }
    }

    try {
      const election = await client.getUserElectionForFeature(feature);
      setState({ election, loading: false, error: undefined });
    } catch (err: any) {
      setState({ election: undefined, loading: false, error: err });
      return;
    }
  }, [feature]);

  return state;
}

export default useExperiment;
